/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { demoteCoordinatorUrl } from '@modules/cloud-api/v1/urls'
import type { RegionId } from '@modules/ui-types'

import { DEMOTE_COORDINATOR } from '../../constants/actions'
import asyncRequest from '../asyncRequests'

import type { ThunkAction } from '@/types/redux'

export function demoteCoordinator(regionId: RegionId, coordinatorId: string): ThunkAction {
  const url = demoteCoordinatorUrl({ regionId, coordinatorId })

  return asyncRequest({
    type: DEMOTE_COORDINATOR,
    url,
    meta: { regionId, coordinatorId },
    method: 'post',
    crumbs: [regionId, coordinatorId],
  })
}
